import { X, AlertTriangle } from 'lucide-react';

interface GridLevelValidationModalProps {
  isOpen: boolean;
  onClose: () => void;
  errors: string[];
}

/**
 * Modal component that displays grid-level validation errors before allowing backend validation
 */
const GridLevelValidationModal = ({ isOpen, onClose, errors }: GridLevelValidationModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full mx-4 max-h-[80vh] overflow-hidden flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center text-red-600">
            <AlertTriangle className="h-6 w-6 mr-2" />
            <h2 className="text-xl font-bold text-gray-900">Field Mapping Validation Errors</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 mb-4">
            The following validation errors must be resolved before you can save and test this
            mapping:
          </p>
          <p className="text-gray-600 text-sm">
            Please review and fix these issues, then try saving again.
          </p>
        </div>

        {/* Scrollable content area */}
        <div className="flex-1 overflow-y-auto">
          <div className="space-y-3">
            {errors.map((error, index) => (
              <div key={index} className="p-4 bg-red-50 border border-red-200 rounded-md">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <AlertTriangle className="h-5 w-5 text-red-400 mt-0.5" />
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-red-800">{error}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-6 flex justify-end pt-4 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            Close & Fix Issues
          </button>
        </div>
      </div>
    </div>
  );
};

export default GridLevelValidationModal;
